const CONTRACT_VARIABLE_SCHEMA = [
  { key: "empresa", label: "Razón social del empleador" },
  { key: "ruc_empresa", label: "RUC del empleador" },
  { key: "empleador_domicilio_legal", label: "Domicilio legal del empleador" },
  { key: "representante_legal", label: "Nombre del representante legal" },
  { key: "representante_legal_cargo", label: "Cargo del representante legal" },

  { key: "trabajador_nombre", label: "Nombre completo del trabajador" },
  { key: "trabajador_dni", label: "DNI del trabajador" },
  { key: "trabajador_domicilio", label: "Domicilio del trabajador" },
  { key: "trabajador_telefono", label: "Teléfono del trabajador" },
  { key: "trabajador_correo", label: "Correo electrónico del trabajador" },
  { key: "cargo", label: "Cargo del trabajador" },
  { key: "codigo_ocupacional", label: "Código ocupacional" },
  { key: "lugar_trabajo", label: "Lugar de prestación de servicios" },

  { key: "tipo_contrato", label: "Tipo de contrato" },
  { key: "fecha_inicio", label: "Fecha de inicio" },
  { key: "fecha_fin", label: "Fecha de fin" },
  { key: "jornada", label: "Jornada laboral (horas semanales)" },
  { key: "sueldo", label: "Remuneración mensual (con S/)" },
  { key: "monto_sueldo", label: "Monto de remuneración (solo número)" },
  { key: "moneda_sueldo", label: "Moneda de remuneración" },
  { key: "periodo_prueba_meses", label: "Periodo de prueba (meses)" },
  { key: "fecha_fin_periodo_prueba", label: "Fecha de término del periodo de prueba" },

  { key: "ciudad_jurisdiccion", label: "Ciudad de jurisdicción" },
  { key: "ciudad_firma", label: "Ciudad de firma" },
  { key: "fecha_firma_dia", label: "Día de firma" },
  { key: "fecha_firma_mes", label: "Mes de firma" },
  { key: "fecha_firma_anio", label: "Año de firma" },
  { key: "fecha_firma", label: "Fecha de firma (texto completo)" },

  { key: "app_nombre", label: "Nombre de la app/plataforma" },

  { key: "firma_empleador_nombre", label: "Nombre en firma del empleador" },
  { key: "firma_empleador_cargo", label: "Cargo en firma del empleador" },
  { key: "firma_trabajador_nombre", label: "Nombre en firma del trabajador" },
  { key: "firma_trabajador_dni", label: "DNI en firma del trabajador" },
];

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_\s]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

const CONTRACT_VARIABLE_ALIASES = {
  // Empleador
  empresa_nombre: "empresa",
  empleador_razon_social: "empresa",
  razon_social: "empresa",
  employer_name: "empresa",

  empresa_ruc: "ruc_empresa",
  empleador_ruc: "ruc_empresa",
  employer_ruc: "ruc_empresa",

  employer_address: "empleador_domicilio_legal",

  representante_legal_nombre: "representante_legal",
  representante_legal_empleador: "representante_legal",
  empleador_representante_legal_nombre: "representante_legal",
  employer_legal_representative_name: "representante_legal",

  empleador_representante_legal_cargo: "representante_legal_cargo",
  employer_legal_representative_title: "representante_legal_cargo",

  // Trabajador
  nombre_trabajador: "trabajador_nombre",
  trabajador_nombre_completo: "trabajador_nombre",
  employee_name: "trabajador_nombre",

  dni: "trabajador_dni",
  employee_dni: "trabajador_dni",

  employee_address: "trabajador_domicilio",

  // Contacto trabajador
  telefono: "trabajador_telefono",
  telefono_trabajador: "trabajador_telefono",
  celular: "trabajador_telefono",
  celular_trabajador: "trabajador_telefono",
  numero_telefonico: "trabajador_telefono",
  numero_telefono: "trabajador_telefono",
  numero_de_telefono: "trabajador_telefono",
  phone: "trabajador_telefono",
  employee_phone: "trabajador_telefono",

  correo: "trabajador_correo",
  correo_trabajador: "trabajador_correo",
  email: "trabajador_correo",
  email_trabajador: "trabajador_correo",
  correo_electronico: "trabajador_correo",
  correo_electronico_trabajador: "trabajador_correo",
  employee_email: "trabajador_correo",

  trabajador_cargo: "cargo",
  employee_position: "cargo",

  trabajador_codigo_ocupacional: "codigo_ocupacional",
  employee_occupational_code: "codigo_ocupacional",

  lugar_de_trabajo: "lugar_trabajo",
  centro_trabajo: "lugar_trabajo",
  work_location: "lugar_trabajo",

  // Condiciones
  jornada_laboral_horas_semanales: "jornada",
  ordinary_weekly_hours: "jornada",
  weekly_work_hours: "jornada",

  remuneracion_basica_mensual: "sueldo",
  remuneracion_mensual_monto: "sueldo",
  remuneracion: "sueldo",
  salario: "sueldo",
  monthly_salary: "sueldo",
  monthly_salary_amount: "sueldo",
  monthly_salary_currency: "moneda_sueldo",

  sueldo_monto: "monto_sueldo",
  monto_remuneracion: "monto_sueldo",
  sueldo_numero: "monto_sueldo",

  probation_period_months: "periodo_prueba_meses",
  fecha_termino_periodo_prueba: "fecha_fin_periodo_prueba",
  termino_periodo_prueba: "fecha_fin_periodo_prueba",
  fin_periodo_prueba: "fecha_fin_periodo_prueba",
  fecha_termino_prueba: "fecha_fin_periodo_prueba",
  fecha_fin_prueba: "fecha_fin_periodo_prueba",
  fecha_vencimiento_periodo_prueba: "fecha_fin_periodo_prueba",
  vencimiento_periodo_prueba: "fecha_fin_periodo_prueba",
  probation_period_end_date: "fecha_fin_periodo_prueba",

  // Firma / ciudad
  jurisdiction_city: "ciudad_jurisdiccion",
  signature_city: "ciudad_firma",
  contract_signing_city: "ciudad_firma",
  contract_signing_day: "fecha_firma_dia",
  contract_signing_month: "fecha_firma_mes",
  contract_signing_year: "fecha_firma_anio",

  // Plataforma
  mi_boleta_platform_name: "app_nombre",

  // Firmas
  employer_legal_representative_name_signature: "firma_empleador_nombre",
  employee_name_signature: "firma_trabajador_nombre",
  employee_dni_signature: "firma_trabajador_dni",
};

const CONTRACT_VARIABLE_KEYS = CONTRACT_VARIABLE_SCHEMA.map((v) => v.key);
const CONTRACT_VARIABLE_KEY_SET = new Set(CONTRACT_VARIABLE_KEYS);

const canonicalizeContractVariableKey = (value) => {
  const normalized = normalize(value);
  const alias = CONTRACT_VARIABLE_ALIASES[normalized] || normalized;
  return CONTRACT_VARIABLE_KEY_SET.has(alias) ? alias : alias;
};

const canonicalizePlaceholdersInText = (text) =>
  String(text || "").replace(/{{\s*([a-zA-Z0-9_]+)\s*}}/g, (_, token) => {
    const canonical = canonicalizeContractVariableKey(token);
    return `{{${canonical}}}`;
  });

const CONTRACT_VARIABLES_PROMPT = CONTRACT_VARIABLE_KEYS.map((key) => `- ${key}`).join("\n");

export {
  CONTRACT_VARIABLE_SCHEMA,
  CONTRACT_VARIABLE_KEYS,
  CONTRACT_VARIABLE_ALIASES,
  canonicalizeContractVariableKey,
  canonicalizePlaceholdersInText,
  CONTRACT_VARIABLES_PROMPT,
};

const contractVariableSchema = {
  CONTRACT_VARIABLE_SCHEMA,
  CONTRACT_VARIABLE_KEYS,
  CONTRACT_VARIABLE_ALIASES,
  canonicalizeContractVariableKey,
  canonicalizePlaceholdersInText,
  CONTRACT_VARIABLES_PROMPT,
};

export default contractVariableSchema;
